import { useQuery } from '@tanstack/react-query';
import type { AdminOverviewResult } from '@casetrace/shared';
import { listAdminOverview } from '../lib/callables';

export function useAdminOverview() {
  return useQuery<AdminOverviewResult>({
    queryKey: ['admin-overview'],
    queryFn: listAdminOverview,
  });
}
